<template>
    <div class=''>
        <loading ref="loading"></loading>
        <b-modal centered ref="fullImageDialog" title="" size="lg" dialog-class='align-items-stretch'>
            <template v-if='show_controls'>
                <div ref='imageScrollContainer' draggable="false" class="text-center modal-image-container h-100" style="overflow: hidden">
                    <p v-if='!in_image.data'>{{ $t('translations.loading_image') }}</p>
                    <img v-else 
                        ref='rImage'
                        v-on:dragstart="return false;"
                        v-on:mousedown='startDrag' 
                        v-on:mousemove='drag' 
                        v-on:mouseup='stopDrag' 
                        v-on:load='initImagePosition()' 
                        :src='in_image.data' 
                        v-bind:style="transImageStyle"
                        draggable='false'>
                </div>
                <!-- <img :width='in_image.width' :height='in_image.height' style='max-width: 100%; max-height: 100%;' :src='in_image.data'> -->
                <div slot="modal-footer" class="w-100 d-flex justify-content-between align-items-start">
                    <a v-on:click='initImageDownload($event, in_image, getImageDownloadName(thread, in_image.id))' v-if='in_image.data && thread && thread.user' class='float-left btn btn-primary' :href='in_image.data' :download='getImageDownloadName(thread, in_image.id)'>{{ $t('translations.download') }}</a>

                    <div class="image-update-tools" style='user-select: none'>
                        <span @click="rotateLeft" class="rotate-left"></span>
                        <span @click="rotateRight" class="rotate-right"></span>
                        <span @click="zoomIn" class="zoom-in"></span>
                        <span @click="zoomOut" class="zoom-out"></span>
                    </div>

                    <b-btn size="sm" class="float-right" variant="primary" v-on:click.prevent='hide'>
                        {{ $t('translations.close') }}
                    </b-btn>
                </div>
            </template>
            <template v-else>
                <div class="text-center">
                    <p v-if='!in_image.data'>{{$t('translations.loading_image')}}</p>
                    <img v-else style='max-width: 100%; max-height: 100%;' :src='in_image.data'>
                </div>
            </template>
		</b-modal>
    </div>
</template>

<script>
	export default {
        extends: app.base.attachmentHelper,
		props: {
            title: {
                default: "Search"
            },
            in_image: {
                default: null
            },
            thread: {
                default: null
            },
            show_controls: {
                default: false
            }
		},
		data: function(){
			return {
                maxZoom: 6,
                minZoom: 0.2,
                rotateDeg: 0,
                zoomScale: 1,
                translateX: 0,
                translateY: 0,
                marginTop: 0,
                dragging: false,
			};
		},
		computed: {
            transImageStyle() {
                var width, height;

                if(this.rotateDeg == 90 || this.rotateDeg == 270) {
                width = this.in_image.height * this.zoomScale;
                    height = this.in_image.width * this.zoomScale;
                }
                else {
                    width = this.in_image.width * this.zoomScale;
                    height = this.in_image.height * this.zoomScale;
                }

                return { 
                    width: "" + width + "px", 
                    height: "" + height + "px", 
                    marginTop: "" + this.marginTop + "px",
                    //transform: 'rotate('+this.rotateDeg+'deg)',
                    cursor: 'move',
                    "userselect": 'none',
                    "userdrag": 'none',
                    "userselect": 'none',
                    "-mozuserselect": 'none',
                    "-webkituserdrag": 'none',
                    "-webkituserselect": 'none',
                    "-msuserselect": 'none',
                };
            },
        },
		mounted() {

        },
        watch: {

        },
		methods: {
            show() {
                this.$refs.fullImageDialog.show();
            },
            hide() {
                this.$refs.fullImageDialog.hide();
            },
            initImagePosition() {
                Vue.nextTick(() => {
                    this.setInitialZoom();
                })
                // Vue.nextTick(() => {
                //     Vue.nextTick(() => {
                //         this.$refs.imageScrollContainer.scrollTop = (this.$refs.imageScrollContainer.scrollHeight - this.$refs.imageScrollContainer.clientHeight) * .5;
                //         this.$refs.imageScrollContainer.scrollLeft = (this.$refs.imageScrollContainer.scrollWidth - this.$refs.imageScrollContainer.clientWidth) * .5;

                //     })
                // })
            },
            rotate() {
                var canvas = document.createElement("canvas");
                var context = canvas.getContext("2d");
                var image = new Image;
                image.src = this.in_image.data;
                var angrad = this.rotateDeg * Math.PI /180;
                var sin = Math.sin(angrad);
                var cos = Math.cos(angrad);
                var width = Math.abs(image.width*cos)+Math.abs(image.height*sin);
                var height = Math.abs(image.height*cos)+Math.abs(image.width*sin);
                
                //console.log(image.width,image.height,width,height);

                canvas.width = width;
                canvas.height = height;
                context.clearRect(0, 0, width, height);
                context.save();
                context.translate(width / 2, height / 2);
                context.rotate(angrad);
                context.translate(-image.width / 2, -image.height / 2);
                context.drawImage(image, 0, 0);
                context.restore();

                // Same code from the bound style, but setting it here stops
                // the update from flickering.
                if(this.rotateDeg == 90 || this.rotateDeg == 270) {
                    this.$refs.rImage.width = this.in_image.height * this.zoomScale;
                    this.$refs.rImage.height = this.in_image.width * this.zoomScale;
                }
                else {
                    this.$refs.rImage.width = this.in_image.width * this.zoomScale;
                    this.$refs.rImage.height = this.in_image.height * this.zoomScale;
                }
                this.$refs.rImage.src = canvas.toDataURL();
            },
            
            rotateLeft() {
                this.rotateDeg -= 90
                if(this.rotateDeg < 0) {
                    this.rotateDeg = 270;
                }
                this.rotate();
                this.setMargin();
			},
			rotateRight() {
                this.rotateDeg += 90
                if(this.rotateDeg > 270) {
                    this.rotateDeg = 0;
                }
                this.rotate();
                this.setMargin();
            },
            setMargin() {
                // Bit of a pain this. We can't use flex to centre align the image as it makes the scrolling go crazy.
                // So we just use a top margin instead
                var marginTop;
                if(this.rotateDeg == 90 || this.rotateDeg == 270) {
                    marginTop = (this.$refs.imageScrollContainer.clientHeight - (this.in_image.width * this.zoomScale)) / 2;
                }
                else {
                    marginTop = (this.$refs.imageScrollContainer.clientHeight - (this.in_image.height * this.zoomScale)) / 2;
                }
                //var marginTop = (this.$refs.imageScrollContainer.clientHeight - (this.image.naturalHeight * this.zoomScale)) / 2;
                if(marginTop > 0) {
                    this.marginTop = marginTop;
                }
                else {
                    this.marginTop = 0;
                }
            },
            dragStart(e) {
                return false;
            },
            startDrag(e) {
                this.dragging = true;
                document.addEventListener("mouseup", this.stopDrag);
                console.info(e);
            },
            drag(e) {
                if(this.dragging) {
                    if((this.$refs.imageScrollContainer.scrollHeight - this.$refs.imageScrollContainer.clientHeight) > 0) {

                        if(e.movementY < 0
                                && (this.$refs.imageScrollContainer.scrollHeight - this.$refs.imageScrollContainer.clientHeight) > this.$refs.imageScrollContainer.scrollTop) {
                            this.$refs.imageScrollContainer.scrollTop -= e.movementY;
                        }
                        if(e.movementY > 0
                                && this.$refs.imageScrollContainer.scrollTop > 0) {
                            this.$refs.imageScrollContainer.scrollTop -= e.movementY;
                        }
                    }

                    if((this.$refs.imageScrollContainer.scrollWidth - this.$refs.imageScrollContainer.clientWidth) > 0) {

                        if(e.movementX < 0
                                && (this.$refs.imageScrollContainer.scrollWidth - this.$refs.imageScrollContainer.clientWidth) > this.$refs.imageScrollContainer.scrollLeft) {
                            this.$refs.imageScrollContainer.scrollLeft -= e.movementX;
                        }
                        if(e.movementX > 0
                                && this.$refs.imageScrollContainer.scrollLeft > 0) {
                            this.$refs.imageScrollContainer.scrollLeft -= e.movementX;
                        }
                    }
                    
                }
            },
            stopDrag(e) {
                this.dragging = false;
                document.removeEventListener("mouseup", this.stopDrag);
                console.info(e);
            },
            setScroll() {
                var scrollTopPercent, scrollLeftPercent;

                if((this.$refs.imageScrollContainer.scrollHeight - this.$refs.imageScrollContainer.clientHeight) == 0) {
                    scrollTopPercent = .5;
                }
                else {
                    scrollTopPercent = (1 / (this.$refs.imageScrollContainer.scrollHeight - this.$refs.imageScrollContainer.clientHeight)) * this.$refs.imageScrollContainer.scrollTop;
                }
                // console.log("scrollTopPercent calc", this.$refs.imageScrollContainer.scrollHeight, this.$refs.imageScrollContainer.clientHeight, this.$refs.imageScrollContainer.scrollTop);
                // console.log("scrollTopPercent calc", this.$refs.imageScrollContainer.scrollHeight - this.$refs.imageScrollContainer.clientHeight);
                // console.log("scrollTopPercent calc", 1 / (this.$refs.imageScrollContainer.scrollHeight - this.$refs.imageScrollContainer.clientHeight));
                // console.log("scrollTopPercent calc", (1 / (this.$refs.imageScrollContainer.scrollHeight - this.$refs.imageScrollContainer.clientHeight)) * this.$refs.imageScrollContainer.scrollTop);
                if((this.$refs.imageScrollContainer.scrollWidth - this.$refs.imageScrollContainer.clientWidth) == 0) {
                    scrollLeftPercent = .5;
                }
                else {
                    scrollLeftPercent = (1 / (this.$refs.imageScrollContainer.scrollWidth - this.$refs.imageScrollContainer.clientWidth)) * this.$refs.imageScrollContainer.scrollLeft;
                }
                
                console.log(scrollTopPercent, scrollLeftPercent);

                // The image update seems to happen one tick later than the next tick
                Vue.nextTick(() => {
                    Vue.nextTick(() => {
                        this.$refs.imageScrollContainer.scrollTop = (this.$refs.imageScrollContainer.scrollHeight - this.$refs.imageScrollContainer.clientHeight) * scrollTopPercent;
                        this.$refs.imageScrollContainer.scrollLeft = (this.$refs.imageScrollContainer.scrollWidth - this.$refs.imageScrollContainer.clientWidth) * scrollLeftPercent;
                        this.setMargin();
                    });
                });
            },
            setInitialZoom() {
                console.log(this.in_image.width, this.$refs.imageScrollContainer.clientWidth);
                console.log(this.in_image.height, this.$refs.imageScrollContainer.clientHeight);
                var zoomX = this.in_image.width / this.$refs.imageScrollContainer.clientWidth;
                var zoomY = this.in_image.height / this.$refs.imageScrollContainer.clientHeight;
                console.log(zoomX, zoomY);

                var zoom = Math.max(zoomX, zoomY);

                if(zoom > 1) {
                    this.zoomScale = 1 / zoom;
                    this.setScroll();
                }
            },
			zoomIn() {
                if(this.zoomScale < this.maxZoom) {
                    this.zoomScale += 0.2;
                }
                
                this.setScroll();
                
			},
			zoomOut() {
                this.zoomScale -= 0.2;
                if(this.zoomScale <= this.minZoom) {
                    this.zoomScale = this.minZoom;
                }

                this.setScroll();
            },
		}
    }
</script>
